import './bringoz-volume.filter';
import './bringoz-date-range.filter';
import './bringoz-dimensions.filter';
import './camelCaseToHuman.filter';
import './km-to-meters.filter';
import './oms-packages-volume.filter';
import './oms-packages-weight.filter';
import './order-pallets.filter';
import './order-spots.filter';
import './package-field-name.filter';
import './package-item-value.filter';
import './bringoz-distance.filter';
import './bringoz-speed.filter';
import './bringoz-weight.filter';
import './bringoz-time-ago.filter';
import './bringoz-address.filter';
import './timeWindow.filter';
import './userName.filter';
import './bringoz-phone.filter';
import './bringoz-time.filter';
import './bringoz-prefs.filter';
import './bringoz-phone-prefix.filter';
import './bringoz-capitalize.filter';
import './bringoz-packages-custom-data-display.filter';
import './bringoz-package-custom-data-display.filter';
import './service-time.filter';
import './shortened-text.filter';
import './task-spots.filter';
import './bringoz-distance-symbol.filter';
import './bringoz-duration-formatted.filter';
import './bringoz-duration-exact.filter';
import './bringoz-time-convert.filter';
import './bringoz-time-hhmm.filter';
import './bringoz-total-weight.filter';
import './bringoz-padding-zeros.filter';
import './bringoz-space-words.filter';
import './bringoz-date.filter';
import './package-item-weight.filter';
import './package-pallets.filter';
import './package-spots.filter';
import './package-total-value.filter';
import './bringoz-duration.filter';
import './userInitials.filter';
import './package-volume.filter';
import './bringoz-price.filter';
import './bringoz-price-offer.filter'
import './package-weight.filter';
import './bringoz-price-by-large-distance-unit.filter'
import './bringoz-price-by-small-distance-unit.filter'
import './service-package-volume.filter';
import './service-package-weight.filter';
import './bringoz-full-date.filter';
import './bringoz-meta-data-display.filter';
import './bringoz-package-field.filter';
import './job-packages-pallets.filter';
import './job-packages-volume.filter';
import './job-packages-weight.filter';
import './bringoz-time-by-numbers.filter';
import './price-by-meter-to-site-distance.filter';
import './bringoz-packages-count.filter';
import './bringoz-day.filter';

